import { byUserInteraction } from '@html/_common/utils';

export default function AOTruncateText() {
  const SELECTOR_TRUNCATE_TEXT = '.js-ao-truncate-text';
  const SELECTOR_TRUNCATE_TEXT_SHOW_MORE = '.js-ao-truncate-text-show-more';

  const checkTextOverflow = (element) => {
    if ($(element)[0].clientHeight < $(element).prop('scrollHeight')) {
      const showMoreText = $(element).data('show-more');
      $(element).parent().append(`<button class="ao-truncate-text-show-more js-ao-truncate-text-show-more">${showMoreText}</button>`);
    }
  };

  this.initiate = () => {
    byUserInteraction('check-for-text-overflows', () => {
      const $truncateTexts = $(SELECTOR_TRUNCATE_TEXT);
      if ($truncateTexts.length) {
        $truncateTexts.each((index, element) => {
          checkTextOverflow(element);
        });
      }
    });
    $(document).on('click', SELECTOR_TRUNCATE_TEXT_SHOW_MORE, (event) => {
      event.preventDefault();
      const $clickedShowMore = $(event.currentTarget);
      $clickedShowMore.addClass('hid');
      const $parent = $clickedShowMore.parent();
      $parent.find('.ao-truncate-text').addClass('ao-truncate-text-full');
    });
  };
}
